import type { SizeT } from "@/types/zod/common";

import type { ActionViewT } from "@/types/database/actions";
import CardTemplate from "../../../../../components/common/CardTemplate";
import ActionBody from "./ActionBody";
import ActionTitle from "./ActionTitle";

interface Props {
	action: ActionViewT;
	size?: SizeT;
} // ActionCard.tsx
const ActionCard = ({ action, size }: Props) => {
	const headerContent = <ActionTitle action={action} />;
	const bodyContent = <ActionBody action={action} />;

	return (
		<CardTemplate
			size={size}
			className="bg-indigo-100 border-indigo-300"
			headerContent={headerContent}
			bodyContent={bodyContent}
		/>
	);
};

export default ActionCard;
